import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setImages(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="pt-40 pb-12 px-6 sm:px-10 lg:px-16">
        <div className="max-w-[1600px] mx-auto">
          <p className="eyebrow">Gallery</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[1.02] tracking-tight">
            The Win Room, <span className="italic" style={{ color: "var(--twr-bronze)" }}>seen quietly.</span>
          </h1>
        </div>
      </section>

      <section className="px-6 sm:px-10 lg:px-16 pb-24">
        <div className="max-w-[1700px] mx-auto columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 [column-fill:_balance]">
          {images.map((g, i) => (
            <button key={g.id} onClick={() => setActive(g.url)} data-testid={`gallery-image-${i}`}
              className="block mb-4 w-full break-inside-avoid overflow-hidden group">
              <img src={g.url} alt="" className="w-full h-auto transition-transform duration-700 group-hover:scale-105" />
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-6 cursor-zoom-out"
          data-testid="gallery-lightbox"
        >
          <button onClick={() => setActive(null)} className="absolute top-6 right-6 text-[var(--twr-warm-white)] hover:text-[var(--twr-bronze)]" aria-label="Close">
            <X size={28} />
          </button>
          <img src={active} alt="" className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </div>
  );
}
